// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__maytra_67e0b8', '__maytra_Fallback_67e0b8'"},"className":"__className_67e0b8"};